import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import "../css/TripDetails.css";
import Loading from "./Loading";
import api from "../services/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRoute, faExclamationCircle } from "@fortawesome/free-solid-svg-icons"; 
import DOMPurify from "dompurify";

const TripDetails = () => {
  const { tripGuid } = useParams();
  const navigate = useNavigate();
  const [tripDetails, setTripDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [searchParams] = useSearchParams();

  const buildVariantPath = (variantGuid) => {
    const search = searchParams.toString();
    return search ? `${variantGuid}?${search}` : `${variantGuid}`;
  };

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("pl-PL", { day: "2-digit", month: "2-digit", year: "numeric" });

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const details = await api.getTrip(tripGuid);
        setTripDetails(details);
      } catch (error) {

      } finally {
        setIsLoading(false);
      }
    };

    fetchDetails();
  }, [tripGuid]);

  const isLikelyHtml = (str) => /<\/?[a-z][\s\S]*>/i.test(str);

const renderDescription = (desc) => {
  if (!desc) return null;

  if (typeof desc === "string" && isLikelyHtml(desc)) {
    const safe = DOMPurify.sanitize(desc, {
      USE_PROFILES: { html: true },
      ADD_ATTR: ["target", "rel"],
    });
    return (
      <div
        className="trip-details-description"
        dangerouslySetInnerHTML={{ __html: safe }}
      />
    );
  }

  return <p className="trip-details-description">{desc}</p>;
};

  if (isLoading) {
    return <Loading />;
  }

  if (!tripDetails) {
    return (
      <div className="error-container">
        <FontAwesomeIcon icon={faExclamationCircle} className="error-icon" />
        <h2 className="error-title">Nie udało się załadować szczegółów wycieczki.</h2>
        <button onClick={() => navigate("/")} className="back-button">
          Powrót
        </button>
      </div>
    );
  }

  const { name, description, photo, photoSource, variants } = tripDetails;

  return (
    <div className="trip-details">
      <div className="trip-details-header">
        <img src={photo} alt={name} className="trip-details-image" />
        <h1 className="trip-details-title">{name}</h1>
      </div>
      <p className="trip-details-photo-source">Źródło zdjęcia: {photoSource}</p>
      {renderDescription(description)}

      <div className="trip-variants">
        <h2>Dostępne warianty:</h2>
        {variants.map((variant, index) => (
          <div key={index} className="trip-variant"   onClick={() => navigate(buildVariantPath(variant.guid))}>
            <FontAwesomeIcon icon={faRoute} className="variant-icon" />
            <div className="variant-content">
              <h3 className="variant-name">{variant.name}</h3>
              <p className="variant-dates">
                {formatDate(variant.startDate)} - {formatDate(variant.endDate)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TripDetails;
